// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"348":"ed48aa80","506":"b8582b57","575":"281ac13e","649":"97721671","763":"89536d62","822":"80325c60","896":"de25fba3","941":"a4adcf1a"}[chunkId] + ".chunk.js";
};